import { supabaseClient } from "supabase/supabase";

export const deleteOrganizer = async ({ uid }: { uid: string }) => {
  const query = supabaseClient.from("organizers").delete().eq("uid", uid);
  const { error } = await query;
  if (error) {
    throw error;
  }

  const { data: list } = await supabaseClient.storage
    .from("organizers")
    .list(uid);

  if (list && list.length > 0) {
    const filesToRemove = list.map((x) => `${uid}/${x.name}`);

    const { error: storageError } = await supabaseClient.storage
      .from("organizers")
      .remove(filesToRemove);
    if (storageError) {
      throw storageError;
    }
  }

  return null;
};
